import { Box, VStack } from '@medely/ui-kit';
import React from 'react';
import { FixedFooterLayout } from './FixedFooterLayout';
import { useKeyboardLayout } from '@mp/hooks';

type RenderModalOrPageBottomLayoutProps = {
  isModal: boolean;
  footerActions: React.ReactNode;
  formComponent: React.ReactNode;
};

export const RenderModalOrPageBottomLayout = ({
  isModal,
  footerActions,
  formComponent,
}: RenderModalOrPageBottomLayoutProps) => {
  const { layoutHeight, isKeyboardVisible } = useKeyboardLayout();
  const contentPaddingX = isModal ? 0 : 2;

  const renderPageLayout = () => (
    <FixedFooterLayout
      footerContent={
        !isKeyboardVisible ? (
          <Box
            bgColor="surface.paper"
            px={contentPaddingX}
            py={1}
            borderTopWidth={1}
            borderColor="controls.backing+line"
          >
            {footerActions}
          </Box>
        ) : null
      }
      height={layoutHeight}
    >
      <Box px={contentPaddingX}>{formComponent}</Box>
    </FixedFooterLayout>
  );

  const renderModalLayout = () => (
    <VStack maxHeight="100vh">
      <Box flex={1} px={contentPaddingX}>
        <Box pb={3}>{formComponent}</Box>
      </Box>
      <Box
        position={'absolute'}
        bottom={0}
        left={0}
        right={0}
        borderTopWidth={1}
        borderColor="controls.backing+line"
        px={1}
        py={1}
        bgColor="surface.paper"
        zIndex={1000}
      >
        {footerActions}
      </Box>
    </VStack>
  );

  return <>{isModal ? renderModalLayout() : renderPageLayout()}</>;
};
